import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    taskId: String,
    upscaled: { type: Boolean, default: false }
  }

  static targets = ["button", "icon", "text", "spinner"]

  connect() {
  }

  async downloadFile(event) {
    event.preventDefault()
    
    if (this.isDownloading) return
    
    this.isDownloading = true
    this.showLoadingState()
    
    const params = new URLSearchParams()
    if (this.upscaledValue) {
      params.append("upscaled", "true")
    }
    
    try {
      const response = await fetch(`/downloads/${this.taskIdValue}?${params.toString()}`)
      
      if (!response.ok) throw new Error("Download failed")
      
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement("a")
      const contentDisposition = response.headers.get("content-disposition")
      const filenameMatch = contentDisposition && contentDisposition.match(/filename="?([^"]+)"?/)
      const filename = filenameMatch ? filenameMatch[1] : `face-switch-${this.taskIdValue}.jpg`
      
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
      
      // Keep button disabled until page refresh
      this.buttonTarget.disabled = true
      this.textTarget.textContent = "Downloaded"
      this.hideLoadingState()
    } catch (error) {
      console.error("Download failed:", error)
      this.isDownloading = false
      this.hideLoadingState()
      // Optionally show error state
      this.textTarget.textContent = "Download failed"
    }
  }
  
  showLoadingState() {
    this.buttonTarget.disabled = true
    this.iconTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("hidden")
    this.textTarget.textContent = "Downloading..."
  }
  
  hideLoadingState() {
    this.spinnerTarget.classList.add("hidden")
    this.iconTarget.classList.remove("hidden")
  }
} 